import React from 'react'
import 'slick-carousel/slick/slick.css'; 
import 'slick-carousel/slick/slick-theme.css';
import Slider from 'react-slick';
export default function SliderRoom() {
    const slides = [
        {
          image: "/images/room/HeroRoom/room.jpg",
          content: 'Classic Room',
        },
        {
          image: '/images/room/HeroRoom/deluxe.jpg',
          content: 'Deluxe Room',
        },
        {
          image: '/images/room/HeroRoom/super-deluxe-room5.jpg',
          content: 'Super Deluxe Room',
        },
        {
          image: '/images/room/HeroRoom/Suite-Room-1.jpg',
          content: 'Suite Room',
        },
        {
          image: '/images/room/HeroRoom/ROOMS-5.jpg',
          content: 'Family Suite Room',
        },
      ];
      
      const settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        autoplay: true,
        autoplaySpeed: 3000,
        slidesToShow: 1,
        slidesToScroll: 1,
        pauseOnHover: false,
        fade: true
      };

  return (
  <>
      <div className="slider-wrapper">
      <Slider {...settings}>
        {slides.map((slide, index) => (
          <div key={index}>
            <img src={slide.image} alt={`Slide ${index + 1}`} title='room-slider-title' className="slide-image" />
            <div className="gradient-overlay"></div>
            <div className="slide-content">
              <h1>{slide.content}</h1>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  </>
  )
}
